<template>
  <div>
    <CCard v-if="$auth.isAuthenticated &&  Number($auth.user['https://tlog-online.co.uk/club_id']) > 0">
      <CCardHeader>
        <slot name="header">
          Transfer Centre
        </slot>
      </CCardHeader>
      <CCardBody>
        <CTabs v-if="biddingOpen || offersOpen">
          <CTab title="My Bids" >
          <MyBids />
          </CTab>
          <CTab title="Place Bid" active>
            <PlaceBid />
          </CTab>
          <CTab title="My Team" >
            <ManageTeam />
          </CTab>
        </CTabs>
        <div v-if="!biddingOpen && !offersOpen">The transfer window is not open</div>
      </CCardBody>
    </CCard>
    
  </div>
</template>

<script>
import PlaceBid from './PlaceBid.vue'
import MyBids from './MyBids.vue'
import ManageTeam from './ManageTeam.vue'

export default {
  name: 'Transfers',
  components: {
    PlaceBid,
    MyBids,
    ManageTeam
  },
  created() {
    this.$store.dispatch("loadSiteVarsList");
  },
  computed: {
    biddingOpen: function() {
      for(var i = 0; i < this.$store.state.siteVarsList.list.length; i++) {
        if(this.$store.state.siteVarsList.list[i].name == "bidding_open" && this.$store.state.siteVarsList.list[i].value == "true") {
          return true;
        }
      }
      return this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11;
    },
    offersOpen: function() {
      for(var i = 0; i < this.$store.state.siteVarsList.list.length; i++) {
        if(this.$store.state.siteVarsList.list[i].name == "offers_open" && this.$store.state.siteVarsList.list[i].value == "true") {
          return true;
        }
      }
      return this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11;
    }
  }
}
</script>
